import React, { useState, useContext } from "react";
import { Spinner } from "@chakra-ui/react";
import UserContext from "../State/UserContext";
import rules from "../utils/rules.json";

export default function Socios() {
    const [loading, setLoading] = useState(false);
    const [numCred, setNumCred] = useState("");
    const [socioData, setSocioData] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const { user } = useContext(UserContext);

    const checkRules = (codiplan) => {
        let validPlan = true;
        try {
            const ruleList = rules.rules;
            for (let i = 0; i < ruleList.length; i++) {
                if (ruleList[i].plan[0].nombre == codiplan) {
                    for (let j = 0; j < ruleList[i].plan[1].prestadores.length; j++) {
                        if (ruleList[i].plan[1].prestadores[j] == user.user.providerCuit) {
                            validPlan = false;
                        }
                    }
                }
            }
            return validPlan;
        } catch (error) {
            return validPlan;
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter" && numCred) search();
    };

    async function search() {
        setLoading(true);
        setSocioData(null);
        setErrorMessage(null);
        const body = { numCred, userToken: user?.token };
        const response = await fetch("provider/getInfoSocio", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
        });

        if (response.status === 200) {
            const data = await response.json();
            if (data.hasOwnProperty("Afiliado")) {
                setSocioData(data);
                setErrorMessage(null);
            } else {
                setErrorMessage("El servicio de consulta de socios no se encuentra disponible en este momento. Por favor intenta realizar la consulta en unos minutos.");
                setSocioData(null);
            }
        } else {
            setErrorMessage("El servicio de consulta de socios no se encuentra disponible en este momento. Por favor intenta realizar la consulta en unos minutos.");
            setSocioData(null);
        }
        setLoading(false);
    }

    const buildRows = () => {
        if (!socioData) return [];
        const d = socioData;
        const validPlan = checkRules(d.codigoplan);
        const activo = d.Afiliado === "ACTIVO";

        if (activo && validPlan) {
            return [
                ["AFILIADO", d.Afiliado],
                ["FECHA INGRESO", d.Fecha_Ingreso || ""],
                ["NOMBRE", d.nombre || ""],
                ["APELLIDO", d.apellido || ""],
                ["FECHA DE NACIMIENTO", d.fechadenacimiento || ""],
                ["TIPO DE DOCUMENTO", d.tipodocumento || ""],
                ["N° DE DOCUMENTO", d.documento || ""],
                ["CODIGO DEL PLAN", d.codigoplan || ""],
                ["PLAN", d.plan || ""],
                ["CONDICIÓN IVA", d.iva || ""],
            ];
        }
        if (activo && !validPlan) {
            return [
                ["AFILIADO", d.Afiliado],
                ["NOTA", "EL PLAN NO TIENE COBERTURA PARA LA ATENCIÓN."],
                ["NOMBRE", d.nombre || ""],
                ["APELLIDO", d.apellido || ""],
                ["N° DE DOCUMENTO", d.documento || ""],
                ["CODIGO DEL PLAN", d.codigoplan || ""],
                ["PLAN", d.plan || ""],
            ];
        }
        return [["AFILIADO", d.Afiliado]];
    };

    const rows = socioData ? buildRows() : [];

    return (
        <div style={{ display: "flex", fontFamily: "Arial, sans-serif", backgroundColor: "#f0f2f5", justifyContent: "center", alignItems: "center", minHeight: "100vh", flex: 1 }}>
            <style>{`.socios-input::placeholder { color: rgba(98, 134, 172, 0.5); }`}</style>
            <div style={{ padding: 30, display: "flex", gap: 24, justifyContent: "center", alignItems: "flex-start" }}>
                {/* Consulta */}
                <div style={{  backgroundColor: "#fff", borderRadius: 12, padding: "40px 50px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
                    <h1 style={{ textAlign: "center", color: "#4A6F96", fontSize: 24, fontWeight: "bold", letterSpacing: 1, marginBottom: 10, textTransform: "uppercase" }}>
                        Consulta de Afiliados
                    </h1>
                    <p style={{ color: "#888", fontSize: 14, marginBottom: 30 }}>
                        Ingrese los datos del socio para obtener informacion de su cobertura
                    </p>
                    <label style={{ fontWeight: "bold", color: "#004990", fontSize: 14, marginBottom: 8, display: "block" }}>
                        Numero de Credencial:
                    </label>
                    <input
                        className="socios-input"
                        type="text"
                        value={numCred}
                        onChange={(e) => setNumCred(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder="Numero de credencial (N° de socio seguido del numero de beneficiario)"
                        style={{
                            width: "100%",
                            padding: "14px 16px",
                            border: "1px solid rgba(98, 134, 172, 0.5)",
                            borderRadius: 8,
                            backgroundColor: "#FFFFFF",
                            fontSize: 14,
                            color: "#666",
                            outline: "none",
                            boxSizing: "border-box",
                            marginBottom: 16,
                            boxShadow: "0 2px 12px rgba(133, 130, 208, 0.35)",
                        }}
                    />
                    <button
                        onClick={() => search()}
                        disabled={loading}
                        style={{
                            width: "100%",
                            padding: "14px",
                            backgroundColor: "#004990",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            fontSize: 15,
                            fontWeight: "bold",
                            cursor: loading ? "not-allowed" : "pointer",
                            letterSpacing: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                        }}
                    >
                        {loading ? <Spinner size="sm" color="white" /> : "Buscar"}
                    </button>
                </div>

                {/* Datos del Afiliado */}
                <div style={{ width: 420, backgroundColor: "#fff", borderRadius: 12, padding: "40px 36px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
                    <h2 style={{ textAlign: "center", color: "#4A6F96", fontSize: 20, fontWeight: "bold", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>
                        Datos del Afiliado
                    </h2>
                    <hr style={{ border: "none", borderTop: "0.75px solid #033261", marginBottom: 24 }} />

                    {loading ? (
                        <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                            <Spinner size="lg" color="#2980b9" />
                        </div>
                    ) : errorMessage ? (
                        <p style={{ color: "#555", textAlign: "center", marginTop: 40, fontSize: 14 }}>
                            {errorMessage}
                        </p>
                    ) : socioData && rows.length > 0 ? (
                        <div>
                            {rows.map(([label, value]) => (
                                <div key={label} style={{ display: "flex", padding: "14px 0", borderBottom: "1px solid #f0f0f0" }}>
                                    <div style={{ width: 200, fontWeight: "bold", color: "#004990", fontSize: 13, textTransform: "uppercase" }}>{label}</div>
                                    <div style={{ flex: 1, color: label === "NOTA" ? "#004990" : "#555", fontSize: 14 }}>{value}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p style={{ color: "#bbb", textAlign: "center", marginTop: 40, fontSize: 14 }}>
                            Busque un afiliado para ver sus datos
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}
